import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import {render} from "react-dom";
import clientconfigwebapp, {
    empty_bk, convert_to_english_strhk, scrollTo_uphk, check_login_appbk, Token_get_appbk, redirectbh_typeb,
} from '../../../clientconfigwebapp';
import {ToastContainer, toast} from 'react-toastify';

import Master_Front_Buyer from "../../Master_Front_Buyer";


import "../../../components/assets/css/profile.css"
import "../../../assets/cssnew/panel.css"

import ReactFullPageLoadinghk from "../../../components/layaout/LoadingFullpagehk";


import Tab1_view from "../../../components/Panel_Simple/Profile_edit/Tab1_view";


import Grid from '@mui/material/Grid';


import {Back, Iconbk_edit1, Information} from '../../../assets/icones/icones';



const Comments = () => {
    const location = useLocation()
    const {tab_show_by_url} = useParams();


    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const [profile_src, setData_profile_src] = useState('');
    const [type_user_panel, setData_type_user_panel] = useState('');
    /*  end profile */
    const [active_tab_curent, set_active_tab_curent] = useState("tab1")

    const [Data_Full_Get, set_Data_Full_Get] = useState([]);



    const [description_me_user_input, set_description_me_user_input] = useState('');


    useEffect(() => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
            return false;
        }


        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page = () => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };

        Setloadinghkfullshow("true");

        const params = new URLSearchParams();
        params.append('page', "edit_profile");


        axios.post(`${clientconfigwebapp.siteurl}api/v1/dashboard-get`, params, config)
            .then((res) => {
                Setloadinghkfullshow("false");
                console.log(res.data);
                if (String(res.data).length > 0) {

                    if (String(res.data.data) == "login-show") {
                        redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                    }

                    if (!empty_bk(res.data.type_user)) {
                        setData_type_user_panel(res.data.type_user);
                    }
                       if (String(res.data).length > 0) {    set_Data_Full_Get(res.data);  }


                    if (String(res.data.wallet_inventory).length > 0) {
                        setData_wallet_balance(res.data.wallet_inventory);
                    }

                    if (!empty_bk(res.data.first_name_profile)) {
                        setData_first_name_profile(res.data.first_name_profile);
                        localStorage.setItem('first_name_Get', res.data.first_name_profile);
                    }
                    if (!empty_bk(res.data.last_name_profile)) {
                        setData_last_name_profile(res.data.last_name_profile);
                        localStorage.setItem('last_name_Get', res.data.last_name_profile);
                    }


                    if (!empty_bk(res.data.profile_src)) {
                        setData_profile_src(res.data.profile_src);
                    }




                } else {
                    if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            }).catch((err) => {
            Setloadinghkfullshow("false");
            toast.error('خطا اتصال به سرور کد  435346', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });


    }


    const Handler_Chanche_description_me_input = (event) => {
        set_description_me_user_input(convert_to_english_strhk(event.target.value));
    }

    const Handler_Sendform = () => {
        if (check_login_appbk() === false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
        }

        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        Setloadinghkfullshow("true");

        let form_data = document.querySelector('#form_data');
        if (form_data != null) {
            let formDatanew = new FormData(form_data);
            formDatanew.append("step", "1");
            let data_serialize = new URLSearchParams(formDatanew).toString();

            axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/send-comments`, data_serialize, config)
                .then((res) => {
                    Setloadinghkfullshow("false");
                    if (String(res.data).length > 0) {
                        if (String(res.data.data) === "login-show") {
                            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                        }
                        if (String(res.data.status) === "success") {

set_active_tab_curent('tab2')
                            form_data.reset();
                            toast.success("پیام شما با موفقیت ارسال شد", {
                                position: "top-center",
                                autoClose: 8000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });


                        } else {
                            if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        }
                    } else {
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                }).catch((err) => {
                Setloadinghkfullshow("false");
                toast.error('خطا اتصال به سرور کد  6786324', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
        }
    }



    return (<Fragment>

            <Master_Front_Buyer type_user_panel={type_user_panel} wallet_balance={wallet_balance}
                                first_name_profile={first_name_profile} last_name_profile={last_name_profile}
                                profile_src={profile_src}>
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>
                <ToastContainer/>

                <div className={"box-content-panelbk"}>

                    <span className={"title-box-content-panel"}>نظرسنجی </span>

                    <div className={"container-bk"}>

                        <form id={"form_data"} name={"form_data"} encType="multipart/form-data"
                              style={{width: "100%"}}>


                            <div style={{
                                width: "100%",
                                "flexDirection": "column",
                                display: String(active_tab_curent) === 'tab1' ? 'flex' : 'none'
                            }}>


                                <Grid container direction="row" spacing={2} style={{paddingTop: "14px"}}>

                                    <div style={{
                                        background: 'rgb(243, 244, 246)',
                                        borderRadius: '16px',
                                        padding: '12px',
                                        width: '1000%',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>به بازارانو چه امتیازی می‌دهید؟<br/><span
                                        style={{display: 'block', fontSize: '13px', marginTop: '9px'}}> با ثبت امتیاز خود به افزایش کیفیت ارائه خدمات کمک کنید.</span>
                                    </div>
                                    <span style={{
                                        "fontSize": "16px",
                                        "display": "block",
                                        "marginTop": "18px"
                                    }}>ثبت نظر</span>

                                    <textarea
                                        name={"description"}
                                        style={{
                                            width: "100%",
                                            height: "132px",
                                            border: "solid 1px #e4e4e4",
                                            borderRadius: "10px",
                                            padding: "11px",
                                            fontSize: "13px",
                                            marginTop: "4px",
                                            marginBlock: "4px"
                                        }}
                                        aria-multiline={8}
                                        onChange={Handler_Chanche_description_me_input}
                                        value={description_me_user_input}
                                        placeholder={""}
                                    ></textarea>


                                    <div style={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-end"
                                    }}>
                                        <button className={"btn-bk-new btn-bk-new-blue btn-full-mobile"} type="button"
                                                style={{marginTop: "10px", marginBottom: "22px"}}
                                                onClick={Handler_Sendform}>
                                           ارسال نظر
                                        </button>
                                    </div>


                                </Grid>


                            </div>


                            <div style={{
                                width: "100%",
                                "flexDirection": "column",
                                "paddingTop": "28px",
                                "paddingBottom": "25px",
                                display: String(active_tab_curent) === 'tab2' ? 'flex' : 'none'
                            }}>


                                <div style={{
                                    "width": "100%",
                                    "flexDirection": "column",
                                    "paddingTop": "28px",
                                    "paddingBottom": "13px",
                                    "display": "flex",
                                    "justifyContent": "center",
                                    "alignItems": "center"
                                }}>
                                    <svg width={63} height={63} viewBox="0 0 63 63" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_0_4438)">
                                            <path
                                                d="M31.5 5.66669C17.24 5.66669 5.66663 17.24 5.66663 31.5C5.66663 45.76 17.24 57.3334 31.5 57.3334C45.76 57.3334 57.3333 45.76 57.3333 31.5C57.3333 17.24 45.76 5.66669 31.5 5.66669ZM26.3333 44.4167L13.4166 31.5L17.0591 27.8575L26.3333 37.1059L45.9408 17.4984L49.5833 21.1667L26.3333 44.4167Z"
                                                fill="#0E9F6E"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_0_4438">
                                                <rect width={62} height={62} fill="white"
                                                      transform="translate(0.5 0.5)"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span style={{
                                        fontSize: '22px',
                                        fontWeight: 'bold',
                                        marginBottom: '30px',
                                        marginTop: '30px'
                                    }}>موفق</span>
                                    <span style={{
                                        fontSize: '15px',
                                        color: '#4B5563',
                                        fontFamily: '"iran"',
                                        display: 'block',
                                        textAlign: 'center',
                                        "lineHeight": "1.6"
                                    }}>
                                      نظر شما با موفقیت ارسال شد.
                                    </span>


                                </div>


                            </div>


                        </form>

                    </div>

                </div>


            </Master_Front_Buyer>
        </Fragment>
    );
}


export default Comments;